import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  consultarFiltradas,
  ObtenerPresentacionComprobante,
} from "./services/presentaciones.service";
import { PresentationFilter } from "./utilities/presentaciones.classes";
import { NumericFormat } from "react-number-format";
import { GetDateLocal, setEsLocale } from "../shared/utilitties/formatDate";
import { Viewer } from "../shared/components/viewer";
import { Toast } from "primereact/toast";
import { useHistory } from "react-router-dom";
import { Tooltip } from "primereact/tooltip";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { HttpStatusCode } from "axios";

import {
  INICIADA_COMERCIO,
  RECHAZADA,
} from "../cargarPresentacion/utilities/constants";
import { CMB_PRESENTATIONS, INIT_PRES_STATUSES } from "./utilities/constant";
import Mask from "../shared/components/mask/Mask";
import { ProgressSpinnerDemo } from "../shared/components/progressSpinnerDemo/ProgressSpinnerDemo";
import { getProductosComercio } from "../cargarPresentacion/services/comercio.service";
import { PrivateRoutes } from "../shared/models/routes";
import { PresentacionesComercio } from "../cargarPresentacion/models/PresentacionesComercio.model";
import { useGlobalContext } from "../shared/context/global.context";
import ListChipState from "./components/ListChipState";

import "primereact/resources/primereact.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./presentaciones.scss";
import "../shared/components/viewer.css";
import '../../pages/shared/styles/datePicker.scss'
import ScanOCR_OK   from "../../images/SCAN_OK.svg";
import ScanOCR_MIX  from "../../images/SCAN_MIX.svg";
import ScanOCR_ERROR from "../../images/SCAN_ERROR.png";

interface Presentaciones {
  pre_cupon: number;
  fecha_presentacion: string;
  fecha_liquidacion: string;
  estatus: string;
  Producto: string;
  Volúmen: string;
  motivo_rechazo: string;
  Acciones: boolean;
}

const initFilters: PresentationFilter = {
  from: undefined,
  to: undefined,
  text: "",
  status: INIT_PRES_STATUSES,
};

const Presentaciones = () => {
  const { setPresentacionesIniciadas, presentacionesIniciadas } =
    useGlobalContext();
  const [data, setData] = useState<Presentaciones[]>([]);
  const [loader, setLoader] = useState(false);
  const history = useHistory();
  const toast = useRef<Toast>(null);
  const [loadingTable, setLoadingTable] = useState(false);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(10);
  const [dialogRechazo, setDialogRechazo] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [filters, setFilters] = useState<PresentationFilter>(initFilters);
  const [showModalFile, setShowModalFile] = useState<boolean>(false);
  const [fileCoded, setFileCoded] = useState<{ file: string; name: string }>({
    file: "",
    name: "",
  });
  const [disabledButton, setDisabledButton] = useState(false);

  setEsLocale();
  
  useEffect(() => {
    (async () => {
      if(filters.status.length === 0 ) {
        toast.current?.show({
          life: 2000,
          severity: "warn",
          summary: "Mensaje",
          detail: "Debe seleccionar al menos un estado",
        });
        setData([])
        setPresentacionesIniciadas([])
        return
      }
      setLoadingTable(true);
      const { data, status } = await consultarFiltradas(filters);
      if (status === HttpStatusCode.Ok && data.presentacionesComercio == null) {
        toast.current?.show({
          life: 2000,
          severity: "warn",
          summary: "Mensaje",
          detail: "No se encontraron resultados.",
        });
        setData([])
        setPresentacionesIniciadas([])
        setLoader(true);
        setLoadingTable(false);
        return;
      }
      if (status === HttpStatusCode.Ok && data.presentacionesComercio !== null) {
        const result = data.presentacionesComercio.filter(
          (item: PresentacionesComercio) => item.estatus == 4
        );
        let listPresentacionesIniciadas = result.map(
          (item: PresentacionesComercio) => {
            return item.pre_cupon;
          }
        );
        setPresentacionesIniciadas(listPresentacionesIniciadas);
        setData(data.presentacionesComercio.reverse());
        setLoader(true);
        setLoadingTable(false);
      } else {
        setLoadingTable(false);
        setLoader(true);
      }
    })();
  }, [filters.status]);

  const searchByFilter: () => Promise<void> = async () => {
    if(filters.status.length === 0) {
      toast.current?.show({
        life: 3000,
        severity: "warn",
        summary: "Mensaje",
        detail: "Debe seleccionar al menos un estado",
      });
      setData([])
      setPresentacionesIniciadas([])
      return
    }

    setLoadingTable(true);
    const { data, status } = await consultarFiltradas(filters);
    if (status === HttpStatusCode.Ok && data.presentacionesComercio == null) {
      toast.current?.show({
        life: 3000,
        severity: "warn",
        summary: "Mensaje",
        detail: "No se encontraron resultados.",
      });
      setLoadingTable(false);
      setData([])
      setPresentacionesIniciadas([])
      setLoader(true);
      return;
    }else if (status === HttpStatusCode.Ok) {
      setData(data.presentacionesComercio);
      setLoadingTable(false);
      return;
    }

    setLoadingTable(false);
  };
  const actionBodyTemplate = (rowData: any) => {
    
    return (
      <React.Fragment>
        <span className="p-column-title">Acciones</span>
        <button
          className="p-button-icon"
          aria-label="Filter"
          onClick={() => EditPresentacion(rowData)}
        >
          {rowData.descripcion === INICIADA_COMERCIO ||
          rowData.descripcion === RECHAZADA ? (
            <i className="pi pi-pencil mr-2" />
          ) : (
            <i className="pi pi-eye mr-2" />
          )}
        </button>
        {rowData.descripcion !== INICIADA_COMERCIO &&
          rowData.descripcion !== RECHAZADA && (
            <button
              className="p-button-icon"
              aria-label="Filter"
              onClick={() => getPdf(rowData)}
            >
              <i className="pi pi-file-pdf mr-2"></i>
            </button>
          )}
      </React.Fragment>
    );
  };
  const formatTypeRequest = (rowData: any) => {
        if(rowData.pretype === "OCR_FULL")
        {       
            return(
            <>
            <span className="p-column-title">type</span> 
                <img 
                src={ScanOCR_OK} 
                alt="DataScan" 
                title="Este comprobante fue cargado con DataScan y leído mediante IA" 
                style={{ width: 22, height: 22, objectFit: "contain", verticalAlign: "middle" }} 
                />
            </> )
        }
        if(rowData.pretype === "OCR_MIXED")
        {
            return (
                <>
            <span className="p-column-title">type</span> 
                <img 
                src={ScanOCR_MIX} 
                alt="DataScan" 
                title="Este comprobante fue cargado con DataScan y modificado manualmente" 
                style={{ width: 22, height: 22, objectFit: "contain", verticalAlign: "middle" }} 
                />
            </> )
        }
        return (
        <>
            <span className="p-column-title">type</span> 
            <span></span> 
        </> )
    };

  const EditPresentacion = async (rowData: any) => {
    let rd = JSON.stringify(rowData);
    history.push({
      pathname: PrivateRoutes.CARGAR_PRESENTACION,
      search: `?presentacion=${rowData.pre_cupon}`,
      state: `${rd}`,
    });
  };

  const getPdf = async (rowData: any) => {
    setLoadingTable(true);
    setFileCoded({ ...fileCoded, name: rowData.nombrePDF });
    setShowModalFile(true);
    if (rowData.nombrePDF) {
      const { data, status } = await ObtenerPresentacionComprobante(
        rowData.nombrePDF
      );
      if (status == HttpStatusCode.Ok && data.success) {
        setFileCoded({ file: data.imgBase64, name: data.nombreImagen });
      } else {
        setShowModalFile(false);
        toast.current?.show({
          life: 5000,
          severity: "info",
          summary: "Mensaje",
          detail: "Archivo no encontrado",
        });
      }
      setLoadingTable(false);
    }
  };

  const downloadFile = (b64: any, fileName: string) => {
    const pdfLink = `data:application/pdf;base64,${b64}`;
    const anchorElement = document.createElement("a");
    const fileNames = `${fileName}.pdf`;
    anchorElement.href = pdfLink;
    anchorElement.download = fileNames;
    anchorElement.click();
  };

  const onRowEditValidator = (rowData: any) => {
    let value = rowData["inventoryStatuses"];
    return value.length > 0;
  };

  const fechaBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        <span className="p-column-title">Fecha De Presentación</span>
        {GetDateLocal(rowData.fecha_presentacion)}
      </React.Fragment>
    );
  };
  const fechaLiqBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        <span className="p-column-title">Fecha Estimada De Pago</span>
        {rowData.fecha_liquidacion != null
          ? GetDateLocal(rowData.fecha_liquidacion)
          : ""}
      </React.Fragment>
    );
  };

  const statusBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        <span className="p-column-title">Estado</span>
        {rowData.descripcion}
      </React.Fragment>
    );
  };

  const productBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        <span className="p-column-title">Producto</span>
        {rowData.presentacionReembolso.producto_descripcion}
      </React.Fragment>
    );
  };

  const volumenBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        <span className="p-column-title">Volúmen</span>
        <NumericFormat
          value={rowData.presentacionReembolso.neto}
          displayType={"text"}
          thousandSeparator={"."}
          decimalSeparator={","}
          prefix={"$"}
          decimalScale={2}
          fixedDecimalScale={true}
        />
      </React.Fragment>
    );
  };

  const setearMotivoRechazo = (rowData: any) => {
    const qty = 80;
    if (rowData.length > qty) {
      return rowData?.substr(0, qty) + " ...";
    } else return rowData;
  };

  const motivoRechazoBodyTemplate = (rowData: any) => {
    if (rowData.motivo_rechazo != undefined && rowData.motivo_rechazo != "") {
      return (
        <div style={{ textAlign: "center" }}>
          <Tooltip target=".p-button-rounded" position="left" />
          <Button
            className="p-button-rounded p-button-outlined"
            data-pr-tooltip={setearMotivoRechazo(
              rowData.motivo_rechazo
                .replace("<ul>", "")
                .replace("</ul>", "")
                .replace("<li>", "")
                .replace("</li>", "")
            )}
            style={{ height: "1.5rem", border: 0 }}
            onClick={() => showDialogMotivoRechazo(rowData.motivo_rechazo)}
          >
            <i
              className="pi pi-exclamation-circle"
              style={{ color: "red", fontSize: "1.5rem" }}
            ></i>
          </Button>
        </div>
      );
    }
  };

  const showDialogMotivoRechazo = (e: any) => {
    setDialogRechazo(e);
    setShowDialog(true);
  };

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cerrar"
        icon="pi pi-times"
        onClick={() => onHide()}
        className="p-button-secondary"
      />
    </React.Fragment>
  );

  const dialogMotivoRechazo = (
    <React.Fragment>
      <Dialog
        modal
        header="Detalle motivo de rechazo"
        visible={showDialog}
        contentStyle={{ flexDirection: "column", overflow: "auto" }}
        style={{ width: "50vw", display: "flex", maxHeight: "90%" }}
        footer={dialogFooter}
        onHide={() => onHide()}
      >
        <div dangerouslySetInnerHTML={{ __html: dialogRechazo }}></div>
      </Dialog>
    </React.Fragment>
  );
  const onHide = () => {
    setShowDialog(false);
  };

  const onCustomPage2 = (event: any) => {
    setFirst2(event.first);
    setRows2(event.rows);
  };

  const template2 = {
    layout:
      "RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
    RowsPerPageDropdown: (options: any) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 50, value: 50 },
      ];

      return (
        <>
          <span
            className="mx-1"
            style={{ color: "var(--text-color)", userSelect: "none" }}
          >
            Presentaciones por página:{" "}
          </span>
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
            style={{ width: "8%" }}
          />
        </>
      );
    },
    CurrentPageReport: (options: any) => {
      return (
        <span
          style={{
            color: "var(--text-color)",
            userSelect: "none",
            width: "120px",
            textAlign: "center",
          }}
        >
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      );
    },
  };

  const crearPresentacion = async () => {
      console.log("crearPresentacion")
    if (presentacionesIniciadas.length >= 3) {
      toast.current?.show({
        sticky: true,
        life: 5000,
        severity: "warn",
        summary: "Mensaje",
        detail:
          "Solo puedes tener hasta tres presentaciones en estado iniciado",
      });
      setDisabledButton(true);
      console.log("mas de 3 no puede")
      return;
    }

    const resultProductosComercio = await getProductosComercio();

    if (
      resultProductosComercio.status === HttpStatusCode.Ok &&
      resultProductosComercio.data.grupoProductos.length > 0
    ) {
      history.push({ pathname: PrivateRoutes.CARGAR_PRESENTACION });
    } else {
      if (
        resultProductosComercio.status === HttpStatusCode.Ok &&
        resultProductosComercio.data.grupoProductos.length == 0
      ) {
        toast.current?.show({
          life: 5000,
          severity: "warn",
          summary: "Mensaje",
          detail:
            "El comercio no tiene habitado ninguna solución de Combustible o Mantenimiento de Flota. Por favor comuníquese con su asesor comercial.",
        });
      } else {
        toast.current?.show({
          life: 5000,
          severity: "info",
          summary: "Mensaje",
          detail: "Algo salió mal",
        });
      }
    }
  };

  const statusTemplate: (status: {
    label: string;
    short: string;
  }) => JSX.Element = (status) => {
    if (!status) return <div className="eden-chip-ph eden-chip ">{""}</div>;

    const { label, short } = status;
    return <div className="eden-chip-item eden-chip">{short}</div>;
  };

  const handlerDate = (val:any,param:string)=>{
    console.log(val)
    if(param ==='to'){
      setFilters({ ...filters, to: val })
    }else{
      setFilters({ ...filters, from: val })
    }
  }

  const renderHeader = (title: string) => {
    const colClass = (nlg: number = 2, nsm: number = 6) =>
      `p-col p-lg-${nlg} p-md-4 p-sm-${nsm} p-d-inline-flex p-ai-center p-p-0`;

    return (
      <>
        <div className="p-d-flex p-flex-wrap p-ai-center p-jc-between">
          <div className="p-d-flex p-flex-wrap p-ai-center mb-2">
            <div className="p-d-flex p-ai-center mt-2 mr-2">
              <p className="mr-1">Desde:</p>
              <Calendar
                inputStyle={{ width: "120px"}}
                minDate={undefined}
                maxDate={filters?.to == undefined || filters?.to == null ? undefined : filters?.to}
                value={filters.from}
                locale={'es'}
                dateFormat="dd/mm/yy"
                showButtonBar={true}
                onChange={(e) => handlerDate(e.value,'from')} 
                />
            </div>
            <div className="p-d-flex p-ai-center mt-2 mr-2">
              <p className="mr-1">Hasta:</p>
              <Calendar
                inputStyle={{ width: "120px"}}
                minDate={filters?.from}
                maxDate={new Date()}
                value={filters.to}
                locale={'es'}
                dateFormat="dd/mm/yy"
                showButtonBar={true}
                onChange={(e) => handlerDate(e.value,'to')} 
                />
            </div>
            <div className="p-d-flex p-ai-center mt-2 mr-2">
              <p className="mr-1">Presentación:</p>
              <InputText
                value={filters.text}
                type="search"
                style={{ borderRadius: "inherit",width:"120px" }}
                onInput={(e: any) =>
                  setFilters({ ...filters, text: e.target.value })
                }
              />
            </div>
            <div className="p-d-flex p-ai-center mt-2 mr-2 ml-2">
              <div className="button-demo">
                <div className="template" style={{ marginLeft: "auto" }}>
                  <Button
                    className="twitter p-0"
                    aria-label="Filtrar"
                    onClick={searchByFilter}
                    style={{minWidth:"140px"}}
                  >
                    <i
                    className="pi pi-search px-2"
                  ></i>
                    <span className="px-3">Filtrar</span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="p-d-flex p-ai-center mb-2">
            <div className={"button-demo " }>
              <div className="template" style={{ marginLeft: "auto" }}>
                <Button
                  className={disabledButton ? "discord p-0" : "vimeo p-0"}
                  aria-label="Crear Presentacion"
                  onClick={crearPresentacion}
                  disabled={disabledButton}
                  style={{minWidth:"140px"}}
                >
                  <i
                    className={
                      disabledButton ? "pi pi-times px-2" : "pi pi-plus px-2"
                    }
                  ></i>
                  <span className="px-3">Crear Presentación</span>
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="p-d-flex p-flex-wrap p-ai-center mb-2">
          {/* <div className="p-d-flex pr-2"> */}
          <div className="p-d-flex p-ai-center mt-2 mr-2">
            <span className="">Estado:</span>
          </div>
          <ListChipState
            selectedStatusPre={filters}
            setSelectedStatusPre={setFilters}
          />
        </div>
      </>
    );
  };
   
  


  const footer = `Presentación y fecha de pago sujetas a revisión a satisfacción de Edenred Argentina S.A.`;
  return (
    <div>
      {!loader && (
        <Mask>
          {" "}
          <ProgressSpinnerDemo />{" "}
        </Mask>
      )}
      {dialogMotivoRechazo}
      <Dialog
        maximizable
        modal
        className="eden-file-dialog"
        header={fileCoded.name}
        visible={showModalFile}
        onHide={() => setShowModalFile(false)}
        style={{ width: "75vw", height: "75vh" }}
      >
        <Viewer
          fileStyle={{ height: "inherit", width: "inherit" }}
          format="pdf"
          loading={loadingTable}
          base64={fileCoded.file}
        />
      </Dialog>
      <Toast ref={toast} position="bottom-right" />
      <div className="card">
        <DataTable
          paginator
          paginatorTemplate={template2}
          first={first2}
          rows={rows2}
          onPage={onCustomPage2}
          paginatorClassName="justify-content-end"
          className="mt-6"
          responsiveLayout="scroll"
          value={data}
          sortField="fecha_presentacion"
          sortOrder={-1}
          header={() => renderHeader("Presentaciones")}
          footer={footer}
          editMode="row"
          rowEditValidator={onRowEditValidator}
          loading={loadingTable}
        >
          <Column
            field="pre_cupon"
            header="Presentación"
            style={{ minWidth: "18%" }}
          ></Column>
          <Column
            field="fecha_presentacion"
            header="Fecha De Presentación"
            body={fechaBodyTemplate}
            style={{ minWidth: "18%", textAlign: "center" }}
          ></Column>
          <Column
            field="fecha_liquidacion"
            header="Fecha Estimada De Pago"
            body={fechaLiqBodyTemplate}
            style={{ minWidth: "18%", textAlign: "center" }}
          ></Column>
          <Column
            field="estatus"
            header="Estado"
            body={statusBodyTemplate}
            style={{ minWidth: "18%" }}
          ></Column>
          <Column
            field="Producto"
            header="Solución"
            body={productBodyTemplate}
            style={{ minWidth: "18%" }}
          ></Column>
          <Column
            field="Volumen"
            header="Monto Bruto"
            body={volumenBodyTemplate}
            style={{ textAlign: "right", minWidth: "18%" }}
          ></Column>
          <Column
            field="motivo_rechazo"
            header="Motivo Rechazo"
            body={motivoRechazoBodyTemplate}
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="ia"
            header="IA"
            body={formatTypeRequest}
            style={{ width: "1%" }}
          ></Column>
          <Column
            rowEditor
            body={actionBodyTemplate}
            exportable={false}
            style={{ width: "10%" }}
          ></Column>
        </DataTable>
      </div>
    </div>
  );
};

export default Presentaciones;
